import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const DefaultRoute = () => {
  const { isAuthenticated } = useSelector((state) => state.auth);

  if (isAuthenticated) {
    return <Navigate to="/admin/users" replace />;
  }
  return <Navigate to="/login" replace />;
};

export default DefaultRoute;
